import { render, staticRenderFns } from "./kfzq.vue?vue&type=template&id=7f041c6e&scoped=true"
import script from "./kfzq.vue?vue&type=script&lang=js"
export * from "./kfzq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f041c6e",
  null
  
)

export default component.exports